import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useRefreshSickCertTemplate = () =>
  useMutation({
    mutationFn: async ({ sickCertId, tenantVal }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientsickcert/${sickCertId}/refreshtemplate`
      );

      return response.data;
    },
  });
